import type {
  Citation,
  ExcursionSmall,
  Figure,
  GlossaryItem,
  Outline,
  PageMeta,
  PageVersion,
} from "@op/puck-types";
import { createContext } from "react";

export interface IContentContext {
  outline: { content: Outline; excursions: Record<string, Outline> };
  citations: { content: Citation[]; excursions: Record<string, Citation[]> };
  figures: { content: Figure[]; excursions: Record<string, Figure[]> };
  glossaryItems: GlossaryItem[];
  excursions: ExcursionSmall[];
  versions: PageVersion[];
  meta: PageMeta;
  pdfUrl?: string;
}

export const ContentContext = createContext<IContentContext | null>(null);

export const ContentContextProvider = ContentContext.Provider;
